import { message as $message } from 'antd'
import { queryCountComboTempGoods } from '@/services/goods'

const contactCustomerServiceModel = {
    namespace: 'contactCustomerService',
    state: {
        isShowMyPartnerPage: false,
        isShowOnlineSuppliersPage: false,
        spellIconNum: 0,
        addSpellNum: 0,
    },
    effects: {
        *countComboTempGoods({ payload }, { call, put }) {
            try {
                const res = yield call(queryCountComboTempGoods, payload)
                if (res.success) {
                    const result = { spellIconNum: res.data }
                    yield put({
                        type: 'update',
                        payload: result,
                    })
                    return res.data
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
    },
    reducers: {
        showMyPartnerPage(state, { payload }) {
            return {
                ...state,
                isShowMyPartnerPage: true,
            }
        },
        showOnlineSuppliersPage(state, { payload }) {
            return {
                ...state,
                isShowOnlineSuppliersPage: true,
            }
        },
        update(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default contactCustomerServiceModel
